import { createFileRoute, redirect } from "@tanstack/react-router";
import { FullPageSpinner } from "@/components/ui/full-page-spinner";

export const Route = createFileRoute("/dashboard")({
	beforeLoad: () => {
		throw redirect({ to: "/", replace: true });
	},
	component: () => <FullPageSpinner />,
});
